import { useEffect, useState } from 'react'
import CustomModal from '../../components/CustomModal';
import CustomInput from '../../components/CustomInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useChangePasswordMutation, useGetOperatorProfileQuery, useGetProfileQuery, useUpdateBranchMutation, useUpdateProfileMutation } from '../../redux/api/profileApi/profileApi';
import { IAuthUser } from '../../redux/features/authSlice/authSlice.types';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuth, setActiveTab } from '../../redux/features/authSlice';
import jwt_decode from 'jwt-decode';
import CustomLoading from '../../components/CustomLoading';
import DragNDropImage from '../../components/DragNDropImage';
import { useLocation } from 'react-router-dom';

const Profile = () => {
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [passwordModal, setPasswordModal] = useState(false);
    const [changePassword, passwordResult] = useChangePasswordMutation();
    const [personalInfoModal, setPersonalInfoModal] = useState(false);
    const [branchInfoModal, setBranchInfoModal] = useState(false);
    const { data: profileInfo, isLoading: profileLoading } = useGetOperatorProfileQuery(authData?.id);
    const { data: branchInfo, isLoading: branchInfoLoading } = useGetProfileQuery(authData?.id);
    const [updateProfile, profileResult] = useUpdateProfileMutation();
    const [updateBranch, branchResult] = useUpdateBranchMutation();
    console.log(branchInfo);

    const passwordValidationSchema = Yup.object().shape({
        oldpassword: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Old password is required"),
        newpassword: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("New password is required"),
    });

    const passwordInitialValues = {
        oldpassword: "",
        newpassword: "",
    };

    const passwordFormik = useFormik({
        initialValues: passwordInitialValues,
        validationSchema: passwordValidationSchema,
        onSubmit: async (values, { resetForm }) => {
            const data = {
                oldPassword: values.oldpassword,
                newPassword: values.newpassword
            }
            try {
                await changePassword({ data, profileId: authData?.id }).unwrap();
                setPasswordModal(false);
                resetForm();
                toast.success("Successfully updated password!")
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const personalInfoValidationSchema = Yup.object().shape({
        name: Yup.string().required('Profile name is required'),
    });

    const personalInfoInitialValues = {
        name: '',
        image: ''
    };

    const personalInfoFormik = useFormik({
        initialValues: personalInfoInitialValues,
        validationSchema: personalInfoValidationSchema,
        onSubmit: async (values, { resetForm }) => {
            let data = {
                name: values.name,
                image: values.image,
            }
            try {
                if (typeof values?.image !== 'string' && values?.image !== null && values?.image) {
                    const formData = new FormData();
                    formData.append("image", values?.image);
                    formData.append("key", "e6bfcbf35a533b5f820f6055552fcf3e");
                    const response = await fetch("https://api.imgbb.com/1/upload", {
                        method: "POST",
                        body: formData,
                    });
                    if (response.ok) {
                        const data1 = await response.json();
                        data = {
                            ...data,
                            image: data1?.data?.display_url
                        }
                    }
                }
                await updateProfile({ data, profileId: authData?.id }).unwrap();
                setPersonalInfoModal(false);
                resetForm();
                toast.success("Profile info updated successfully!")
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const branchInfoValidationSchema = Yup.object().shape({
        name: Yup.string().required('Profile name is required'),
        phone: Yup.string().required('Phone number is required'),
        address: Yup.string().required('Address is required'),
    });

    const branchInfoInitialValues = {
        name: '',
        phone: '',
        address: '',
        image: ''
    };

    const branchInfoFormik = useFormik({
        initialValues: branchInfoInitialValues,
        validationSchema: branchInfoValidationSchema,
        onSubmit: async (values, { resetForm }) => {
            let data = {
                name: values.name,
                phone: values.phone,
                address: values.address,
                image: values.image,
            }
            try {
                // if (typeof values?.image !== 'string' && values?.image !== null && values?.image) {
                //     const formData = new FormData();
                //     formData.append("image", values?.image);
                //     formData.append("key", "e6bfcbf35a533b5f820f6055552fcf3e");
                //     const response = await fetch("https://api.imgbb.com/1/upload", {
                //         method: "POST",
                //         body: formData,
                //     });
                //     if (response.ok) {
                //         const data1 = await response.json();
                //         data = {
                //             ...data,
                //             image: data1?.data?.display_url
                //         }
                //     }
                // }
                await updateBranch({ data, branchId: branchInfo?.id }).unwrap();
                setBranchInfoModal(false);
                resetForm();
                toast.success("Branch info updated successfully!")
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    useEffect(() => {
        if (profileInfo) {
            personalInfoFormik.setFieldValue('name', profileInfo?.name);
            personalInfoFormik.setFieldValue('image', profileInfo?.image);
        }
    }, [profileInfo]);

    useEffect(() => {
        if (branchInfo) {
            branchInfoFormik.setFieldValue('name', branchInfo?.name);
            branchInfoFormik.setFieldValue('phone', branchInfo?.phone);
            branchInfoFormik.setFieldValue('address', branchInfo?.address);
            branchInfoFormik.setFieldValue('image', branchInfo?.image);
        }
    }, [branchInfo]);

    useEffect(() => {
        if (pathname === "/profile") {
            dispatch(setActiveTab("Profile"));
        }
    }, [dispatch, pathname]);

    return (
        <div>
            <div className='shadow-lg rounded-lg overflow-hidden'>
                <div>
                    <div className="h-80 w-full object-cover flex justify-end" style={{
                        backgroundImage: `url("https://res.cloudinary.com/di23omfvx/image/upload/v1693288923/Tasnuva-Currier-Cover-Page_grjooj.png")`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center'
                    }}>
                    </div>
                    <div className='px-0 sm:px-12 mb-8 flex flex-col items-end justify-between gap-5 w-full -mt-24'>
                        <div className='flex flex-col w-full gap-5 items-center justify-between sm:items-start'>
                            <div className='w-full flex flex-col xl:flex-row justify-between xl:items-end'>
                                <div className='h-48 w-48 rounded-full bg-white border-4 border-[#9A9FA5] flex items-center justify-center overflow-hidden shadow-lg z-[10000]'>
                                    <img src={profileInfo?.image || 'https://i.ibb.co/8MgR8kC/images.png'} alt='profile' className='w-full h-full object-cover' />
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex flex-col xl:flex-row gap-4 items-end'>
                            <div className='w-full  p-4 flex flex-col justify-between h-full'>
                                <div className='text-2xl text-text_1 font-bold mb-4'>Profile Informations</div>
                                <div className='w-full text-lg font-semibold flex flex-col justify-between h-full gap-5'>
                                    <div className='flex flex-col lg:flex-row xl:flex-col 2xl:flex-row gap-4 w-full'>
                                        <div className='w-full'>
                                            <div>Name</div>
                                            <div className='bg-[#EAEAEC] w-full rounded-lg shadow px-4 py-2 mt-3 font-normal'>{profileInfo?.name}</div>
                                        </div>
                                        <div className='w-full'>
                                            <div>Email</div>
                                            <div className='bg-[#EAEAEC] w-full rounded-lg shadow px-4 py-2 mt-3 font-normal'>{profileInfo?.email}</div>
                                        </div>
                                    </div>
                                    <div className='flex flex-col lg:flex-row xl:flex-col 2xl:flex-row gap-4 w-full'>
                                        <div className='w-full'>
                                            <div
                                                onClick={() => {
                                                    setPersonalInfoModal(true);
                                                }}
                                                className="py-2 px-3 border h-fit border-secondary text-secondary rounded bg-secondary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white"
                                            >
                                                Change Personal Info
                                            </div>
                                        </div>
                                        <div className='w-full'>
                                            <div
                                                onClick={() => {
                                                    setPasswordModal(true);
                                                }}
                                                className="py-2 px-3 border h-fit border-primary text-primary rounded bg-primary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-primary hover:animate-pulse hover:text-white"
                                            >
                                                Change Password
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {profileInfo?.isManager && <div className='w-full p-4 flex flex-col justify-between h-full'>
                                <div className='text-2xl text-text_1 font-bold mb-4'>Branch Informations</div>
                                <div className='w-full text-lg font-semibold flex flex-col justify-between h-full gap-5'>
                                    <div className='flex flex-col lg:flex-row xl:flex-col 2xl:flex-row gap-4 w-full'>
                                        <div className='w-full'>
                                            <div>Name</div>
                                            <div className='bg-[#EAEAEC] w-full rounded-lg shadow px-4 py-2 mt-3 font-normal'>{branchInfo?.name}</div>
                                        </div>
                                        <div className='w-full'>
                                            <div>Phone</div>
                                            <div className='bg-[#EAEAEC] w-full rounded-lg shadow px-4 py-2 mt-3 font-normal'>{branchInfo?.phone}</div>
                                        </div>
                                    </div>
                                    <div className='flex flex-col lg:flex-row xl:flex-col 2xl:flex-row gap-4 w-full items-end'>
                                        <div className='w-full'>
                                            <div className='w-full'>
                                                <div>Address</div>
                                                <div className='bg-[#EAEAEC] w-full rounded-lg shadow px-4 py-2 mt-3 font-normal'>{branchInfo?.address}</div>
                                            </div>
                                        </div>
                                        <div className='w-full'>
                                            <div
                                                onClick={() => {
                                                    setBranchInfoModal(true);
                                                }}
                                                className="py-2 px-3 border h-fit border-secondary text-secondary rounded bg-secondary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white"
                                            >
                                                Change Branch Info
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {!profileInfo?.isManager && <div className="h-40 hidden xl:flex w-full items-end justify-end">
                                <img
                                    src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                                    alt="self drive"
                                    className="h-full"
                                />
                            </div>}
                        </div>

                    </div>
                </div>

            </div>
            <CustomModal
                showModal={passwordModal}
                setShowModal={setPasswordModal}
                submitButton={true}
                handleSubmit={passwordFormik.handleSubmit}
                title={"Change Password"}
            >
                <form
                    onSubmit={passwordFormik.handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <CustomInput
                        label="OLD PASSWORD"
                        type="password"
                        setFieldValue={passwordFormik.setFieldValue}
                        value={passwordFormik.values.oldpassword}
                        touched={passwordFormik.touched.oldpassword}
                        error={passwordFormik.errors.oldpassword}
                        handleBlur={passwordFormik.handleBlur}
                    />
                    <CustomInput
                        label="NEW PASSWORD"
                        type="password"
                        setFieldValue={passwordFormik.setFieldValue}
                        value={passwordFormik.values.newpassword}
                        touched={passwordFormik.touched.newpassword}
                        error={passwordFormik.errors.newpassword}
                        handleBlur={passwordFormik.handleBlur}
                    />
                </form>
            </CustomModal>

            <CustomModal
                showModal={personalInfoModal}
                setShowModal={setPersonalInfoModal}
                submitButton={true}
                handleSubmit={personalInfoFormik.handleSubmit}
                title={"Change Profile Information"}
            >
                <form
                    onSubmit={personalInfoFormik.handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className='w-full md:w-[40%] xl:w-[30%] gap-3 flex flex-col'>
                        <label className="font-semibold text-text_2">PROFILE IMAGE</label>
                        <DragNDropImage
                            style={{
                                height: "200px",
                            }}
                            setFiles={(file) => personalInfoFormik.setFieldValue('image', file[0])}
                            backgroundImg={
                                (typeof personalInfoFormik.values?.image !== 'string' && personalInfoFormik.values?.image !== '' && personalInfoFormik.values?.image !== null)
                                    ? URL.createObjectURL(personalInfoFormik.values?.image)
                                    : personalInfoFormik.values?.image
                                        ? personalInfoFormik.values?.image
                                        : null
                            }
                        />
                    </div>
                    <CustomInput
                        label="NAME"
                        type="text"
                        setFieldValue={personalInfoFormik.setFieldValue}
                        value={personalInfoFormik.values.name}
                        touched={personalInfoFormik.touched.name}
                        error={personalInfoFormik.errors.name}
                        handleBlur={personalInfoFormik.handleBlur}
                    />
                </form>
            </CustomModal>

            <CustomModal
                showModal={branchInfoModal}
                setShowModal={setBranchInfoModal}
                submitButton={true}
                handleSubmit={branchInfoFormik.handleSubmit}
                title={"Change Branch Information"}
            >
                <form
                    onSubmit={branchInfoFormik.handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    {/* <div className='w-full md:w-[40%] xl:w-[30%] gap-3 flex flex-col'>
                        <label className="font-semibold text-text_2">PROFILE IMAGE</label>
                        <DragNDropImage
                            style={{
                                height: "200px",
                            }}
                            setFiles={(file) => personalInfoFormik.setFieldValue('image', file[0])}
                            backgroundImg={
                                (typeof personalInfoFormik.values?.image !== 'string' && personalInfoFormik.values?.image !== '' && personalInfoFormik.values?.image !== null)
                                    ? URL.createObjectURL(personalInfoFormik.values?.image)
                                    : personalInfoFormik.values?.image
                                        ? personalInfoFormik.values?.image
                                        : null
                            }
                        />
                    </div> */}
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="NAME"
                            type="text"
                            setFieldValue={branchInfoFormik.setFieldValue}
                            value={branchInfoFormik.values.name}
                            touched={branchInfoFormik.touched.name}
                            error={branchInfoFormik.errors.name}
                            handleBlur={branchInfoFormik.handleBlur}
                        />
                        <CustomInput
                            label="PHONE"
                            type="number"
                            setFieldValue={branchInfoFormik.setFieldValue}
                            value={branchInfoFormik.values.phone}
                            touched={branchInfoFormik.touched.phone}
                            error={branchInfoFormik.errors.phone}
                            handleBlur={branchInfoFormik.handleBlur}
                        />
                    </div>
                    <CustomInput
                        label="ADDRESS"
                        type="text"
                        setFieldValue={branchInfoFormik.setFieldValue}
                        value={branchInfoFormik.values.address}
                        touched={branchInfoFormik.touched.address}
                        error={branchInfoFormik.errors.address}
                        handleBlur={branchInfoFormik.handleBlur}
                    />
                </form>
            </CustomModal>

            {(profileLoading || passwordResult.isLoading || branchInfoLoading || profileResult.isLoading || branchResult.isLoading
            ) && <CustomLoading />}
        </div>
    )
}

export default Profile